import { render, staticRenderFns } from "./GlobalStyleForm.vue?vue&type=template&id=76b552da&scoped=true"
import script from "./GlobalStyleForm.vue?vue&type=script&lang=js"
export * from "./GlobalStyleForm.vue?vue&type=script&lang=js"
import style0 from "./GlobalStyleForm.vue?vue&type=style&index=0&id=76b552da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76b552da",
  null
  
)

export default component.exports